<template>
  <v-card v-if="!loading" flat>
    <v-card-text class="mb-3 pb-0">
      <p><strong>Formavimo parametrai</strong></p>
      <template v-if="isEmptyParametrai">
        Įkelti visi objektai
      </template>
      <template v-if="!isEmptyParametrai">
        <v-row>
          <v-col cols="12" md="4">
            <dl>
              <dt>Objekto išregistravimo data nuo</dt>
              <dd>
                {{ parametrai.isregistravimo_data_nuo }}
              </dd>
            </dl>
          </v-col>
          <v-col cols="12" md="4">
            <dl>
              <dt>Objekto išregistravimo data iki</dt>
              <dd>
                {{ parametrai.isregistravimo_data_iki }}
              </dd>
            </dl>
          </v-col>
          <v-col cols="12" md="12">
            <dl>
              <dt>Objektas</dt>
              <dd>
                {{ objektaiText }}
              </dd>
            </dl>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NaikinimasAktasParametrai',
  props: {
    parametrai: Object,
    objektai: Object,
    loading: Boolean,
  },
  data: () => ({
    paslauga: null,
  }),
  computed: {
    isEmptyParametrai() {
      return JSON.stringify(this.parametrai) === '{}'
    },
    objektaiText() {
      if (this.isEmptyParametrai) {
        return ''
      }
      if (this.parametrai.objektai.length == 0) {
        return 'Visi objektai'
      }
      return this.parametrai.objektai
        .map(item => {
          return this.objektai[item]
        })
        .join(', ')
    },
  },
  methods: {
    //
  },
}
</script>
<style lang="scss" scoped>
dt {
  font-weight: 400;
}
dd {
  margin-bottom: 10px;
  padding-top: 2px;
  padding-bottom: 5px;
  min-height: 27px;
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 0, 0, 0.57);
}
</style>
